import React from 'react';
import classnames from 'classnames/bind';
import { Indication, INDICATION_TYPES } from 'taboola-ultimate-ui';
import { useSupplyTargetingAndSiteTargetingValidation } from 'modules/campaigns/modules/common-campaign-form/components/ReachEstimator/hooks/useSupplyTargetingAndSiteTargetingValidation';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './SupplyTargetingAndSiteTargetingValidation.module.scss';

const classNameBuilder = classnames.bind(styles);

const getWarningMessage = shouldShowIncludeWarning => {
    return shouldShowIncludeWarning ? (
        <FormattedMessage
            id="campaign.reach.estimator.supply.targeting.and.include.site.targeting.warning"
            defaultMessage="Available impressions estimation based only on sites included in targeting, regardless of supply targeting"
        />
    ) : (
        <FormattedMessage
            id="campaign.reach.estimator.supply.targeting.and.exclude.site.targeting.warning"
            defaultMessage="Available impressions estimation based only on supply targeting selection, regardless of site targeting"
        />
    );
};

export const SupplyTargetingAndSiteTargetingValidation = () => {
    const { shouldShowIncludeWarning, shouldShowExcludeWarning } = useSupplyTargetingAndSiteTargetingValidation();

    if (!shouldShowIncludeWarning && !shouldShowExcludeWarning) {
        return null;
    }

    const warningMessage = getWarningMessage(shouldShowIncludeWarning);

    return (
        <div className={classNameBuilder('indication')}>
            <Indication type={INDICATION_TYPES.WARNING} displayDismissComponent={false} message={warningMessage} />
        </div>
    );
};
